import { TransactionsParametersExportRecord } from "@zenith/features/Transactions/interfaces";

/**
 * Downloads file from blob.
 * @function
 * @name downloadFileFromBlob
 * @kind function
 * @param {Blob} blob Response from BE when request the download/export file.
 * @param {string} name Name that will be applied to the file.
 * @param {TransactionsParametersExportRecord.mediaType} extension Extension of the file (i.e.: PDF, CSV, etc.).
 * @returns {void}
 * @exports
 */
export function downloadFileFromBlob(
  blob: Blob,
  name: string,
  extension: TransactionsParametersExportRecord.mediaType
): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("href", url);
  link.setAttribute("download", `${name}.${extension.toLocaleLowerCase()}`);
  link.click();
}
